const initialState = {
  user: {},
  filterOptions: {},
  selectedFilters: {},
  cartDetails: {},
  entries: [],
  currentEntry: {},
  hasItems: false,
  totalCartAmount: 0,
  bundleTypeAndQuantities: [],
  userSessionForBundles: {},
  // Countries state
  countries: [],
  countriesLoading: false,
  countriesError: null,
  // Currencies state
  currencies: [],
  currenciesLoading: false,
  currenciesError: null,
  // Service Categories state
  serviceCategories: [],
  serviceCategoriesLoading: false,
  serviceCategoriesError: null,
  // Service Subcategories state
  serviceSubcategories: [],
  serviceSubcategoriesLoading: false,
  serviceSubcategoriesError: null,
  // Amenities state
  amenities: [],
  amenitiesLoading: false,
  amenitiesError: null,
};

export default initialState;
